<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p class="loading-text">Loading...</p>
</ngx-spinner>
<router-outlet></router-outlet>

<!-- Floating Icons Container -->
<div class="floating-icons-container">
  <!-- WhatsApp Icon -->
  <a href="https://wa.me/919087003398" target="_blank" class="whatsapp-btn" title="Contact Us on WhatsApp">
    <i class="bi bi-whatsapp"></i>
  </a>

  <!-- Scroll to Top Icon -->
  <button (click)="scrollToTop()" [class.show]="showScrollTop" class="scroll-top-btn" title="Scroll to Top">
    <i class="bi bi-arrow-up"></i>
  </button>
</div>